/* eslint-disable import/prefer-default-export */

// Keep it as fuction so that we can evaluate it inside component render phase
export const isSmallScreenWidth = () => window.innerWidth < 840;
